export enum WarningLevels {
  INITIAL,
  MODERATE,
  FINAL,
}

export enum DocumentsStatus {
  PENDING,
  ANALYSIS_IN_PROGRESS,
  OK,
  PENDING_OFFICIAL,
  OFFICIAL_ANALYSIS_IN_PROGRESS,
}
